<template>
  <v-form
    v-model="valid"
    class="py-8 bg-light-blue-main">
    <v-row class="pa-4">
      <v-col cols="12">
        <DescriptionPart
          :id="id"
          class="bordered bg-white" />
      </v-col>
      <v-col cols="12">
        <ProductionsPart
          :id="id"
          class="bordered bg-white" />
      </v-col>
      <v-col cols="12">
        <ShiftsTablePart
          class="bordered bg-white"
          :shift-model-id="id" />
      </v-col>
      <v-col cols="12">
        <ShiftModelDeductionsTablePart
          class="bordered bg-white"
          :shift-model-id="id" />
      </v-col>
      <v-col cols="12">
        <AvailabilityPart
          :id="id"
          class="bordered bg-white" />
      </v-col>
    </v-row>
  </v-form>
</template>

<script setup>
import { ref, computed } from "vue";
import { useRoute } from "vue-router";

import AvailabilityPart from "./AvailabilityPart.vue";
import DescriptionPart from "./DescriptionPart.vue";
import ProductionsPart from "./ProductionsPart.vue";
import ShiftsTablePart from "./ShiftTable.vue";
import ShiftModelDeductionsTablePart from "./ShiftModelDeductionTable.vue";
import { useSpaceStore } from "@/stores/spaceStore";

const spaceStore = useSpaceStore();

const valid = ref(false);

const props = defineProps({
  closeDialog: {
    type: Function,
    required: true
  },
  locationId: {
    type: String,
    required: true
  },
  id: {
    type: String,
    required: true
  }
});

const route = useRoute();

const id = computed(() => route.params.nodeId);
</script>

<style>
/* .v-form {
  max-height: 100%;
  overflow: auto;
  background-color: white;
} */
</style>
